module.exports = __webpack_public_path__ + "static/img/qinghai.2b9a71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/qinghai.png
// module id = WcB1
// module chunks = 93